import { render } from "./ResourceComponentPopup.vue?vue&type=template&id=1046a168&scoped=true"
import script from "./ResourceComponentPopup.vue?vue&type=script&lang=js"
export * from "./ResourceComponentPopup.vue?vue&type=script&lang=js"

import "./ResourceComponentPopup.vue?vue&type=style&index=0&id=1046a168&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1046a168"]])

export default __exports__